import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { http } from '@/apis/aipass'
import { SurveyParams, SurveyResponse } from './survey-types'
import { env } from '@/libs/env'
import qs from 'qs'

export const fetchSurvayQuestions = createAsyncThunk<SurveyResponse, SurveyParams, { rejectValue }>(
  'survey/fetchSurvayQuestions',
  async (params, { rejectWithValue }) => {
    try {
      const response = await http({
        method: 'get',
        url: `${env('BASE_API_V3')}/guest/surveys`,
        params: {
          hotelId: params.hotelId,
          reservationIds: params.reservationIds,
        },
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: 'brackets' })
        },
      })
      return response.data
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

interface SurveyQuestionsState {
  survey: SurveyResponse | null
  loading: boolean
}

const initialState: SurveyQuestionsState = {
  survey: null,
  loading: false,
}

const surveyQuestionsSlice = createSlice({
  name: 'surveyQuestions',
  initialState,
  reducers: {
    resetSurveyQuestions: state => {
      state.survey = null
      state.loading = false
    },
  },
  extraReducers: builder => {
    builder.addCase(fetchSurvayQuestions.fulfilled, (state, action) => {
      state.survey = action.payload
      state.loading = false
    })
    builder.addCase(fetchSurvayQuestions.rejected, state => {
      state.loading = false
    })
    builder.addCase(fetchSurvayQuestions.pending, state => {
      state.loading = true
    })
  },
})

export const { resetSurveyQuestions } = surveyQuestionsSlice.actions
export const surveyQuestionsReducer = surveyQuestionsSlice.reducer
